import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	selectAll: {
		id: 'business-list.list-view.select-row-cell.select-all',
		defaultMessage: 'Select all issues',
		description: 'Hidden accessibility label for bulk select all checkbox',
	},
	selectIssue: {
		id: 'business-list.list-view.select-row-cell.select-issue',
		defaultMessage: 'Select {issueKey}',
		description: 'Hidden accessibility label for bulk select checkbox',
	},
	selectAllIssueTermRefresh: {
		id: 'business-list.list-view.select-row-cell.select-all-issue-term-refresh',
		defaultMessage: 'Select all work items',
		description: 'Hidden accessibility label for bulk select all checkbox',
	},
});
